import { Box, HStack, Skeleton, SkeletonCircle, Stack, VStack } from "@chakra-ui/react";
import React from "react";

function SkeletonAgentData() {
  return (
    <HStack gap="2"  p={2}>
      <SkeletonCircle size="8" />
      <Stack flex="1">
        <Skeleton height="4" />
        <Skeleton height="4" width="80%" />
      </Stack>
    </HStack>
  );
}

function SkeletonAgentDataList() {
  const listNumber = Array(6).fill(0)
  return (
    <>
      {listNumber?.map((ele) => (
      
          <SkeletonAgentData />
       
      ))}
    </>
  );
}

export default SkeletonAgentDataList;
